<app-table
  [(focusYear)]="focusYear"
  (focusYearChange)="focusYearChanged()"
  [columns]="columns"
  [editable]="true"
  [focusYearRangeStart]="focusYearRangeStart"
  [hasFocusYear]="true"
  [sortField]="'date'"
  #table
  createLabel="HOLIDAYS.ADD_HOLIDAY">
  <ng-template
    (onClick)="addPublicHolidays()"
    appToolbarButton
    icon="fal fa-redo"
    labelKey="HOLIDAYS.ADD_PUBLIC_HOLIDAYS"></ng-template>

  <ng-template
    (onClick)="addLastYearsHolidays()"
    appToolbarButton
    icon="fal fa-calendar-plus"
    labelKey="HOLIDAYS.ADD_LAST_YEARS_HOLIDAYS"></ng-template>
</app-table>
